import { gql } from '@apollo/client';
import { ReportSectionState } from '@mnd-frontend/graphql-schema';
import { GREY_900 } from '@mnd-frontend/ui/shared/tokens';
import type { Report2VisibilityReachOverTimeFragment } from '../../../../../generated/types';
import { ReachOverTimeGraph } from '../../charts';
import { Insights, Section, SectionHeader } from '../../common';

export const REPORT2_VISIBILITY_REACH_OVER_TIME_FRAGMENT = gql`
  fragment Report2VisibilityReachOverTime on ReportVisibilityReachOverTime {
    id
    title
    groupBy
    state
    reach {
      startAt
      endAt
      startAtPreviousYear
      endAtPreviousYear
      week
      month
      reach
      reachPreviousYear
    }
    insights2 {
      id
      title
      insight
      insightType
    }
  }
`;

const VisibilityReachOverTime = ({
  section,
}: {
  section: Report2VisibilityReachOverTimeFragment;
}) => {
  const { reach, insights2, groupBy } = section;

  return (
    <Section>
      <SectionHeader
        color={GREY_900}
        as="h3"
        variant="reportHeadlineLarge"
        section={section}
        isSubsection
      />
      <ReachOverTimeGraph
        loading={section.state !== ReportSectionState.Done}
        groupBy={groupBy}
        reachOverTime={reach}
      />
      <Insights insights={insights2} />
    </Section>
  );
};

export default VisibilityReachOverTime;
